<h1 mat-dialog-title>{{title}} Petition</h1>
<div mat-dialog-content>
    <app-petition-editor [isNewPetition]="data.isNewPetition" [(editPetition)]="editPetition">
    </app-petition-editor>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-button (click)="onSave()">Save</button>
</div>